import { PropsWithChildren, JSX, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import classes from './Modal_legacy.module.scss';

interface IProps {
    close: ICallback;
    targetNode?: keyof HTMLElementTagNameMap;
}

export const Modal_legacy = ({
    targetNode = 'body',
    ...props
}: PropsWithChildren<IProps>): JSX.Element => {
    const modalContainer = document.querySelector(targetNode);
    const el = useRef<HTMLDivElement>(document.createElement('div')).current;

    el.classList.add(classes.backdrop);

    el.addEventListener('click', (event) => {
        if (!el.contains(event.target as Node) || el === event.target) {
            props.close();
        }
    });

    useEffect(() => {
        modalContainer.appendChild(el);
        document.body.classList.add('lock-scroll');

        return () => {
            modalContainer.removeChild(el);
            document.body.classList.remove('lock-scroll');
        };
    }, [el, modalContainer]);

    return createPortal(props.children, el);
};
